export default {
  description: 'Crie e configure os Boards usados para organizar suas oportunidades comerciais.',
  title: 'Boards de Oportunidades',
  fields: {
    name: 'Nome do Board',
    template: 'Template',
    active: 'Ativo',
    acceptModelUpdates: 'Aceitar atualizações automáticas',
  },
  actions: {
    new: 'Novo Board',
    open: 'Abrir Board',
  },
  templateChangeTitle: 'Trocar template do board?',
  templateChangeWarning: 'Ao aceitar, colunas, status e tipos de card serão recriados conforme o novo template. Personalizações atuais da estrutura do board serão substituídas. Esta troca só é permitida enquanto o board não tiver cards.',
  modelUpdates: {
    enableTitle: 'Aceitar atualizações automáticas do modelo?',
    enableMessage: `
      <p>Este Board receberá automaticamente as melhorias que a Núcleo P fizer no modelo,
      como novos campos, ajustes no layout e novos tipos de card.</p>
      <p>Esta opção vale apenas para este Board. Os demais Boards mantêm suas próprias configurações.</p>`,
    disableTitle: 'Parar atualizações automáticas?',
    disableMessage: `
      <p>Este Board deixará de receber futuras atualizações do modelo da Núcleo P
      e manterá sua estrutura atual.</p>
      <p>Os demais Boards não serão afetados.</p>`,
  },
  errors: {
    use_board_template_locked_by_cards: 'O template não pode ser trocado porque o board já possui cards. Atualize a lista e tente novamente.',
    use_board_template_locked_by_model_updates: 'Desative as atualizações automáticas e salve antes de trocar o template.',
  },
};
